<template>
  <svg :width="width" :height="height" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M16.0988 5.6546L18.2799 3.31769C18.6568 2.91393 19.2896 2.89211 19.6933 3.26895C20.0971 3.64578 20.1189 4.27857 19.7421 4.68232L18.0761 6.46729C21.0437 7.96461 23 10.3031 23 12C23 14.6923 18.0751 19 12 19C10.2852 19 8.66212 18.6568 7.21552 18.1036L4.73106 20.7655C4.35422 21.1693 3.72144 21.1911 3.31769 20.8143C2.91393 20.4374 2.89211 19.8047 3.26895 19.4009L5.3167 17.2069C2.69235 15.7116 1 13.5782 1 12C1 9.3077 5.92487 5 12 5C13.4488 5 14.8321 5.24498 16.0988 5.6546ZM14.5625 7.30067C13.7271 7.10471 12.8654 7 12 7C9.60476 7 7.23713 7.80224 5.37974 9.1211C3.87775 10.1876 3 11.4215 3 12C3 12.5785 3.87775 13.8124 5.37974 14.8789C5.80359 15.1799 6.25402 15.4539 6.72528 15.6977L8.45159 13.8481C8.16311 13.2953 8 12.6667 8 12C8 9.79086 9.79086 8 12 8C12.5686 8 13.1096 8.11866 13.5994 8.33257L14.5625 7.30067ZM12.0427 10.0005C12.0285 10.0002 12.0143 10 12 10C10.8954 10 10 10.8954 10 12C10 12.0608 10.0027 12.121 10.008 12.1805L12.0427 10.0005ZM11.2006 13.8339L13.7744 11.0763C13.9185 11.3526 14 11.6668 14 12C14 13.1046 13.1046 14 12 14C11.7158 14 11.4454 13.9407 11.2006 13.8339ZM9.79615 15.3387C10.4281 15.7566 11.1856 16 12 16C14.2091 16 16 14.2091 16 12C16 11.0867 15.6939 10.2449 15.1787 9.57158L16.6453 8.00031C17.3471 8.31163 18.0111 8.68858 18.6203 9.1211C20.1223 10.1876 21 11.4215 21 12C21 12.5785 20.1223 13.8124 18.6203 14.8789C16.7629 16.1978 14.3952 17 12 17C10.8805 17 9.76712 16.8248 8.709 16.5035L9.79615 15.3387Z"
      :fill="color"
    />
  </svg>
</template>

<script lang="ts">
export default {
  name: 'PasswordHideOutlineIcon',
  props: {
    width: {
      type: Number,
      default: 24,
    },
    height: {
      type: Number,
      default: 24,
    },
    color: {
      type: String,
      default: '#99005c',
    },
  },
};
</script>
